import { AxiosError } from 'axios';
import { api } from '../../../../shared/services/api';
import Cookies from 'js-cookie';

export interface CreateAccountGroupDTO {
  account_situation: string;
  type_bdv: string;
}

export interface CreatePersonGroupDTO {
  type_person: string;
  person_name: string;
  cnpj_cpf_person: string;
  type_linked_bdv: string;
  end_date: string;
  start_date: string;
}

export interface PersonGroup {
  id: string;
  type_person: string;
  person_name: string;
  cnpj_cpf_person: string;
  type_linked_bdv: string;
  start_date: string;
  end_date: string;
  account_group_id: string;
  created_at: string;
  updated_at: string;
}

export interface AccountGroup {
  id: string;
  account_situation: string;
  type_bdv: string;
  account_deposit_id: string;
  created_at: string;
  updated_at: string;
  person_groups: PersonGroup[];
}

export interface IResponseCCS0003 {
  id: string;
  number_control_ccs: string;
  account_deposit_number: string;
  start_date: string;
  end_date: string;
  movement_date: string;
  date_time_bacen: string;
  number_control_if: string;
  status: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  account_groups: AccountGroup[];
}

export const createAccountGroup = async (
  id: string,
  values: CreateAccountGroupDTO,
): Promise<{ success: boolean; message?: string }> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    await api.post(`/deposit/account-group/${id}`, values, config);
    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(
        'Erro ao criar grupo:',
        err.response?.data?.error || 'Erro de conexão',
      );
      return {
        success: false,
        message: err.response?.data?.error || 'Erro de conexão',
      };
    } else {
      console.error('Erro inesperado:', err);
      return { success: false, message: 'Erro inesperado' };
    }
  }
};

export const createPersonGroup = async (
  id: string,
  values: CreatePersonGroupDTO,
): Promise<{ success: boolean; message?: string }> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    await api.post(`/deposit/person-group/${id}`, values, config);
    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(
        'Erro ao criar grupo de pessoas:',
        err.response?.data?.error || 'Erro de conexão',
      );
      return {
        success: false,
        message: err.response?.data?.error || 'Erro de conexão',
      };
    } else {
      console.error('Erro inesperado:', err);
      return { success: false, message: 'Erro inesperado' };
    }
  }
};

export const deletePersonGroup = async (
  id: string,
): Promise<{ success: boolean; message?: string }> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    await api.delete(`/deposit/person-group/${id}`, config);
    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      const apiMessage =
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Erro de conexão';
      console.error('Erro ao excluir grupo de pessoas:', apiMessage);
      return {
        success: false,
        message: apiMessage,
      };
    } else {
      console.error('Erro inesperado:', err);
      return { success: false, message: 'Erro inesperado' };
    }
  }
};

export const deleteGroup = async (
  id: string,
): Promise<{ success: boolean; message?: string }> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    await api.delete(`/deposit/account-group/${id}`, config);
    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Erro de conexão';
      console.error('Erro ao excluir grupo:', message);
      return {
        success: false,
        message,
      };
    } else {
      console.error('Erro inesperado:', err);
      return { success: false, message: 'Erro inesperado' };
    }
  }
};

export const deleteAccount = async (
  id: string,
): Promise<{ success: boolean; message?: string }> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    await api.delete(`/deposit/deposit-account/${id}`, config);
    return { success: true };
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(
        'Erro ao excluir grupo:',
        err.response?.data?.message || 'Erro de conexão',
      );
      return {
        success: false,
        message: err.response?.data?.message || 'Erro de conexão',
      };
    } else {
      console.error('Erro inesperado:', err);
      return { success: false, message: 'Erro inesperado' };
    }
  }
};

export const getAccount = async (
  id: string,
): Promise<IResponseCCS0003 | null> => {
  try {
    const token = Cookies.get('@token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };

    const response = await api.get(
      `/deposit/getAll?account_deposit_id=${id}`,
      config,
    );
    return response.data as IResponseCCS0003;
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(
        'Erro ao buscar conta:',
        err.response?.data?.error || 'Erro de conexão',
      );
    } else {
      console.error('Erro inesperado:', err);
    }
    return null;
  }
};
